import { render, staticRenderFns } from "./DocumentReview.vue?vue&type=template&id=3bf2ab60&scoped=true"
import script from "./DocumentReview.vue?vue&type=script&lang=js"
export * from "./DocumentReview.vue?vue&type=script&lang=js"
import style0 from "./DocumentReview.vue?vue&type=style&index=0&id=3bf2ab60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf2ab60",
  null
  
)

export default component.exports